import React from 'react'
import ImageGallery from '../../../overrides/app/components/image-gallery'
import {Box, Flex} from '@chakra-ui/react'
import {libraryImageGalleryData} from '../../../overrides/app/components/image-gallery/__mock__/mock-data'
import HeadingComponentName from '../../components/heading-library'
import {remCalc} from '../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'

const ImageGalleryPage = () => {
    return (
        <Flex flexDir="column" overflow="auto">
            <HeadingComponentName name="ImageGallery" />
            <Box padding={remCalc(40)}>
                <Flex
                    minW={remCalc(345)}
                    maxW={{base: remCalc(345), md: remCalc(580), xl: remCalc(736)}}
                >
                    <ImageGallery
                        imageGroups={libraryImageGalleryData}
                        selectedVariationAttributes={{color: 'BLACKWL'}}
                    />
                </Flex>
            </Box>
        </Flex>
    )
}

export default ImageGalleryPage
